import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import Main from "./components/Main"
import Contact from './components/Contact'
import Hiring from './components/Hiring'

Vue.config.productionTip = false
Vue.use(Router)

const router = new Router({
	routes:[{
		path: '/',
		name: 'home',
		component: Main,
	},{
		path: '/contact',
		name: 'contact',
		component: Contact,
		props: true,
	},{
		path: '/hiring',
		name: 'hiring',
		component: Hiring,
		props: true,
	},]})

new Vue({
	render: h => h(App),
	router,
	data:{
	},
}).$mount('#app')

